<template>
	<div class="tcontainer">
		<Toast />
		<div class="clearfix ttitle">
			<div class="title">
				Change Password
			</div>
		</div>
		<div style="padding: 25px 15px; background: #fff; margin-bottom: 10px; border: 1px solid #ddd; border-top: 0;">

			<div style="max-width: 1000px; margin: auto; ">
				<form @submit.prevent="saveSettings">

					<div class="form-group">
						<label>
							Old Password
							<input type="password" class="form-control" v-model="settings.old_password">
						</label>
					</div>
					<div class="form-group">
						<label>
							New Password
							<input type="password" class="form-control" v-model="settings.new_password">
						</label>
					</div>
					<div class="form-group">
						<label>
							Confirm Password
							<input type="password" class="form-control" v-model="settings.confirm_password">
						</label>
					</div>
					<div class="form-group clearfix">
						<button type="submit" :disabled="saving" class="btn btn-primary pull-right">
							Change Password
						</button>
					</div>
				</form>
			</div>
		</div>

	</div>
</template>

<script>
import Toast from 'primevue/toast';
export default {
	components: {
		Toast
	},
	data() {
		return {
			radiologist: {},
			saving: false,
			settings: {
				old_password: '',
				new_password: '',
				confirm_password: ''
			}
		}
	},
	mounted() {
		this.loadRadiologist();
	},
	methods: {
loadRadiologist() {
			this.get("radiologist/load-radiologist").then(res => {
				this.radiologist = res;
				
			});
		},
		saveSettings() {
			if (this.saving) return;
			this.saving = true;

			if (this.settings.password && this.settings.password.length < 5) {
				this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Password must be at least 5 characters long', life: 3000 });
				this.saving = false;
				return;
			}

			let data = {
				old_password: this.settings.old_password,
				new_password: this.settings.new_password,
				confirm_password: this.settings.confirm_password,
			};
		
			if (!(this.settings.old_password && this.settings.new_password && this.settings.confirm_password)) {
				this.saving = false;
				this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Provide all the fields.', life: 3000 });
				return
			}

			if (this.settings.new_password.length < 5) {
				this.saving = false;
				this.$toast.add({ severity: 'error', summary: 'Error', detail: 'New password must be at least 5 characters', life: 3000 });
				return
			}

			if (this.settings.new_password != this.settings.confirm_password) {
				this.saving = false;
				this.$toast.add({ severity: 'error', summary: 'Error', detail: 'New and Confirm Password doesnot matched', life: 3000 });
				return
			}

			this.upload("radiologist/change-password", data, (err, res) => {
				this.saving = false;			

				if (res.success) {
					this.saving = false;
					this.settings.old_password = '';
					this.settings.new_password = '';
					this.settings.confirm_password = '';
					this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Successfully Changed Password.', life: 3000 });
					delete window.localStorage.radiologist_access_token;
					this.$router.push("/radiologist-login");

				} else {
					this.$toast.add({ severity: 'error', summary: 'Error', detail: res.message, life: 3000 });
				}
			}, p => {
				this.uploadPercentage = Math.round(p * 100);
			})

		}
	}
}
</script>
<style scoped>
label {
	display: block;
}
</style>
